export const timerMixin = {
  // 通用的定时器
  // 使用demo
  /* 
// 引入
import { timerMixin } from "@/util/mixin/timerMixin";
export default {
    mixins: [timerMixin],
    mounted() {
        // 启动定器
        this.startTimer();
    },
    methods: {
        // 重写runs
        runs() {
            //...
        }
 */
  data() {
    return {
      timer: null
    };
  },

  methods: {
    startTimer(cb, times) {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        if (cb instanceof Function) {
          cb();
        } else {
          // 默认执行
          this.runs();
        }
      }, times || this.$config.times);
    },
    // 定时器执行
    runs() {
      //do something
    }
  },
  //销毁前清除定时器
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
